import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms'
import { parsePhoneNumberFromString } from 'libphonenumber-js'
import CountryList from 'country-list-with-dial-code-and-flag'

 // get all countries
 const countryList = CountryList.getAll()
 .map(country => ({
   code: country.code,
   name: country.name,
   dialingCode: country.dial_code,
 }))

export function phoneValidator(countryCodeControlName: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
   
    if (!control.parent) {
      return null
    }

    const countryCode = control.parent.get(countryCodeControlName)?.value
    const phoneNumber = control.value

    if (!countryCode || !phoneNumber) {
      return null
    }

    // get country by code
    const country = countryList.find((country: any) => country.code.toLowerCase() === countryCode.toLowerCase())

    const formattedNumber = phoneNumber.startsWith('+')
      ? phoneNumber
      : phoneNumber.startsWith(country?.dialingCode?.substring(1))
        ? `+${phoneNumber}`
        : `${country?.dialingCode}${phoneNumber}`

    const parsedNumber = parsePhoneNumberFromString(formattedNumber)
    
    return parsedNumber && parsedNumber.isValid()
      ? null
      : { invalidPhone: true }
  }
}
